import { TextLanguage, TranslatedText } from "Store/texts/interfaces";

import { BaseProduct } from "Store/interfaces/products/checkPrice/BaseProduct";
import { ElectricScooterCoverage } from "Store/interfaces/products/coverage";

export interface ElectricScooterPriceRequestInfo extends BaseProduct {
  year: number;
  brand: string;
  model: string;

  injuries: number;
  injuryYear?: number;

  dateOfBirth?: string;
}

export enum ElectricScooterInsuranceType {
  ELECTRIC_SCOOTER_LIABILITY_WITH_ACCIDENT = "electricScooterAnsvarMedUlykke",
  ELECTRIC_SCOOTER_LIABILITY = "electricScooterAnsvar",
  ELECTRIC_SCOOTER_REDUCED_OWN_DAMAGE_WITH_ACCIDENT = "electricScooterDelkaskoMedUlykke",
  ELECTRIC_SCOOTER_REDUCED_OWN_DAMAGE = "electricScooterDelkasko",
  ELECTRIC_SCOOTER_FULL_OWN_DAMAGE_WITH_ACCIDENT = "electricScooterKaskoMedUlykke",
  ELECTRIC_SCOOTER_FULL_OWN_DAMAGE = "electricScooterKasko",
}

type ElectricScooterTile = {
  productIntro: {
    ingress: TranslatedText;
  };
  productPrice: {
    heading: TranslatedText;
    ingress: TranslatedText;
    deductibleInfo: TranslatedText;
  };
};

type ElectricScooterFormTexts = {
  [key: string]: {
    label: TranslatedText;
    hint?: TranslatedText;
    placeholder?: TranslatedText;
    error: Record<string, TranslatedText>;
  };
};
export interface ElectricScooterTexts {
  details: {
    [key: string]: Record<TextLanguage, string>;
  };
  formText: { checkPrice: ElectricScooterFormTexts };
  tile: ElectricScooterTile;
  title: TranslatedText;
  name: TranslatedText;
  types: {
    coverageGroup: Record<ElectricScooterCoverage, TranslatedText>;
  };
}
